import React, {useState,useEffect} from 'react';
import { Breadcrumb } from 'react-bootstrap';
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal';
import SuccessModal from '../../UI/SuccessModal/SuccessModal';
import classes from './Myschedule.module.css';
import Graybg from "../../UI/Graybg";
import userService from '../../app/services/user.service'
import Slider from "react-slick";
import Loader from '../../UI/loader/loader';
import Calender from '../../assets/svg/calendar.svg'; 
import DatePicker from "react-datepicker";
import {isEmpty} from '../../utils/custom_funtions'
import ScheduleCard from './ScheduleCard';


const Myschedule = () => {
    const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
    const [show, setShow] = useState(false)
    const [show1, setShow1] = useState(false)
    const [loading, setLoading] = useState(false)
    const [isCalenderTouched, setIsCalenderTouched] = useState(false)
    const [isDataChanged, setIsDataChanged] = useState(false)
    const [originalDate, setOriginalDate] = useState(new Date())
    const [selectedDate, setSelectedDate] = useState(new Date().toLocaleString("sv-SE").slice(0,10))
    const [datelist, setDateList] = useState([])
    const [ScheduleList, setScheduleList] = useState([])
    const slider = React.useRef(null);

    const onHideHandler = () => {
        setShow(false)
        setShow1(false)
    }
    const yesHandler = () => {
        setShow(false)
        setShow1(true)
    }
    
    const getDateList = () => {
      setLoading(true)
      userService.getDateList(selectedDate)
      .then(res => {
        setDateList(res.data);
        setLoading(false)
        const index = res.data?.findIndex(object => {
          return object.date === selectedDate;
        });
        slider.current.slickGoTo(index);
      })
      .catch(err => {
        console.error(err);
        setLoading(false)
      })
    }
    const getScheduleList = () => {
      setLoading(true)
      const body = {
        faculty_id: user_id,
        date: selectedDate,
      };
      userService.getScheduleList(body)
      .then(res => {
        // setDateList(res.data);
        console.log()
        if(res.data !== "Not Found"){
        setScheduleList(res.data)
        console.log("setScheduleList",res.data)
      } else {
        setScheduleList([])
      }
        setLoading(false)
      })
      .catch(err => {
        console.error(err);
        setLoading(false)
      })
    } 
    useEffect(() => {
      getDateList();
    }, [isCalenderTouched])
    useEffect(() => {
      getScheduleList()
    },[selectedDate, isDataChanged])

    const monthNames =  [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
    const removeDuplicates = (arr) => {
      return [...new Set(arr)]
    }

    let settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 7,
      slidesToScroll: 4,
      cenerPadding:80,
      arrows:false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2
          }
        }
      ],
    };
      const index = datelist?.findIndex(object => {
        return object.date === selectedDate;
      }); 
      const ExampleCustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <>
        <button className={classes.calenderBtn} onClick={onClick} ref={ref}>
          <img src={Calender} alt={value} />
        </button>
        </>
      ));
  return (
    <>
      {loading && <Loader />}
      <div className="section">
        <ConfirmationModal
          show={show}
          onHide={onHideHandler}
          title="Do you want to Delete class details?"
          confirmTxt="Yes"
          yesHandler={yesHandler}
        />
        <SuccessModal
          show={show1}
          onHide={onHideHandler}
          title="Class Details Deleted Successfully!"
          btnTxt="OK"
        />
        <h4>My Schedule</h4>
        <Breadcrumb>
        
          <Breadcrumb.Item active>My Schedule</Breadcrumb.Item>
        </Breadcrumb>
        <Graybg className={classes.faded}>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
          <div className={classes.calenderContainer}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h3 className={classes.month}>
                {monthNames[selectedDate?.slice(5, 7) - 1]}
              </h3>
              <div className={classes.datepickContainer}>
                <DatePicker
                  className={classes.datePicker}
                  selected={originalDate}
                  customInput={<ExampleCustomInput />}
                  withPortal
                  onChange={(date) => {
                    setOriginalDate(date);
                    setSelectedDate(date.toLocaleString("sv-SE").slice(0, 10));
                    setIsCalenderTouched(!isCalenderTouched);
                  }}
                />
              </div>
            </div>
            <Slider {...settings} ref={slider}>
              {datelist.map((data,index) => {
                return (
                  <div>
                    <div
                      className={
                        selectedDate == data.date
                          ? classes.dateCardActive
                          : data.pending_status == 1 ? classes.dateCardPending : classes.dateCard
                      }
                      key={JSON.stringify(data)}
                      onClick={() => {
                        setSelectedDate(data.date);
                        setOriginalDate(new Date(data.date));
                      }}
                    >
                      <p>{data.day.slice(0, 1)}</p>
                      <h4>{data.date.slice(8)}</h4>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
          {isEmpty(ScheduleList) ? <p className='text-center my-4'>Data Not found!</p> :
          <>
          {ScheduleList.map(data => {
            return (

              <ScheduleCard data={data}  idDC={data.topic == "DC" ? true : false} dataChanged={() => setIsDataChanged(prev => !prev)} />
            );
          })}
          </>
        }
          
        </Graybg>
      </div>
    </>
  );
}

export default Myschedule
